export const EMAIL = 'km-group@naver.com';
export const PHONE = '02-477-5007';
export const ADDRESS = '서울특별시 중구 만리재로 37길 3, 4~5층';